import axios from 'axios'
import Toastify from 'toastify-js'
import "toastify-js/src/toastify.css"

export default function contatoForm() {
    const showToastify = (message, opts) => {
        Toastify({
            duration: 3000,
            position: "center",
            style: { background: "rgba(193, 255, 129)", fontSize: "18px", color: "rgba(45, 71, 120, 1)" },
            text: message,
            ...opts
        }).showToast();
    }

    const btnFormContato = document.querySelectorAll('.btn-contact')
    const formContato = document.querySelector('#enter-in-contact')

    if (btnFormContato) {
        btnFormContato.forEach((btn) => {
            formContato && btn.addEventListener('click', function (event) {
                event.preventDefault();
                disabledBtn()

                const primeiro_nome = document.querySelector('#enter-in-contact input[name=nome]');
                //const assunto = document.querySelector('#enter-in-contact input[name=assunto]');
                const email = document.querySelector('#enter-in-contact input[name=email]');
                const box_text = document.querySelector('#enter-in-contact textarea[name=mensagem]');
                const form_data = {
                    nome: `${primeiro_nome.value}`,
                    email: email.value,
                    mensagem: box_text.value,
                    //assunto: assunto.value,
                }

                //console.log(form_data)

                const url = "/fale-conosco/"
                axios.post(url, form_data)
                    .then((response) => showMessage(response))
                    .catch((response) => showMessage(response));
            });
        })
    }

    const Languagem = document.querySelector('[lang]').lang;
    console.log(Languagem);

    function showMessage(response) {
        const isSuccess = response.data && response.data.message;
        // const message = response.data ? response.data.message : response.message

        const Languagem = document.querySelector('[lang]').lang;
        let message = ''
        if (Languagem == 'en') {
            message = isSuccess ? 'Message sent successfully! Thank you!' : 'Oops, something went wrong! Try again!'
        } else {
            message = isSuccess ? 'Mensagem enviada com sucesso! Obrigado!' : 'Oops, aconteceu algo de errado! Tente de novo!'
        }

        const backgroundColor = isSuccess ? "rgba(193, 255, 129)" : "rgba(233, 44, 44)";
        const textColor = isSuccess ? "rgba(45, 71, 120, 1)" : "white";

        showToastify(message, {
            style: {
                background: backgroundColor,
                color: textColor,
                fontSize: "18px",
                borderRadius: "8px"
            },
        });
        formContato.reset()
        setTimeout(enabledBtn, 1000)
    }

    function disabledBtn() {
        btnFormContato.forEach((btn) => {
            btn.disabled = true
            btn.classList.add("disabled")
        })
    }

    function enabledBtn() {
        btnFormContato.forEach((btn) => {
            btn.disabled = false
            btn.classList.remove("disabled")
        })
    }
}